import { DateTimeHelperService } from './date-helper.service';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateTimeFormatPipe } from './date-format.pipe';

@NgModule({
    declarations: [
        DateTimeFormatPipe
    ],
    imports: [ CommonModule ],
    exports: [
        DateTimeFormatPipe
    ],
    providers: [],
})
export class DateHelperModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: DateHelperModule,
            providers: [
                DateTimeHelperService
            ]
        };
    }
}
